import { useEffect, useState } from "react";
import { Form, Col, Row, Modal, Button } from "antd";
import useGet from "../../../global/hooks/useGet";
import usePost from "../../../global/hooks/usePost";
import usePut from "../../../global/hooks/usePut";
import CustomInput from "../../../global/components/inputWidgets/CustomInput";
import { useNavigate, useParams } from "react-router-dom";
import {
  openConfirmNotification,
  openErrorNotification,
} from "../../../global/utils/toast";
import CommonBreadcrumb from "../../../global/components/CommonBreadcrumb";
import CommonButton from "../../../global/components/CommonButton";
import CustomSelect from "../../../global/components/inputWidgets/CustomSelect";
import { getModifiedResponse } from "../../../global/utils/responseModifier";
import {
  CheckCircleOutlined,
  CloseOutlined,
  UnorderedListOutlined,
  EditOutlined,
  DeleteOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import useDelete from "../../../global/hooks/useDelete";
import ConfirmModal from "../../../global/components/ConfirmModal";
import DealerIcon from "../../../assets/images/vectors/SideBarIcons/DealerIcon";
// import AccountForm from "../../../global/components/adminInfo";
import { IoIosCheckmarkCircleOutline } from "react-icons/io";
// import AccountCreationModal from "../../../global/components/AccountCreationModal";
// import OemIcon from "../../../assets/images/vectors/SideBarIcons/OemIcon";
import { RiAlignItemBottomFill } from "react-icons/ri";
import { GlobalTable } from "../../../global/components/GlobalTable";
import { ProductionItemsColumns } from "../Page/ProductionItemsColumns";
import ProductionModal from "./ProductionModal";
import AccountIcon from "../../../assets/images/vectors/SideBarIcons/AccountIcon";
import {
  getProductionListPath,
  getProductionRowId,
} from "../utils/listSearchStorage";

export const ProductionForm = ({
  type,
  onCancel,
  isModalForm,
  setDefaultData: setAccountDefaultData,
  defaultData: accountDefaultData,
}) => {
  const { id } = useParams();

  // const loggedInUser = JSON.parse(sessionStorage.getItem("userData"));
  const [showModal, setShowModal] = useState(false);
  const [showItemsModal, setShowItemsModal] = useState(false);
  const [openModal, setOpenModal] = useState({
    productionItemAddModal: false,
  });
  const [hoveredRow, setHoveredRow] = useState(null);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const productionItemurl =
    id && `${process.env.REACT_APP_API_URL}/api/${id}/production-items/`;
  const {
    data: productionData,
    loading: productionLoading,
    error: productionError,
    refetch: productionRefetch,
  } = useGet(productionItemurl);

  // const [isModalOpen, setIsModalOpen] = useState(false);
  // const [isOpenModal, setIsOpenModal] = useState(false);
  // const [modalType, setModalType] = useState("");
  // const [defaultData, setDefaultData] = useState({
  //   DealerNo: null,
  //   OemNo: null,
  //   CustomerNo: null,
  // });

  const [form] = Form.useForm();
  const navigate = useNavigate();
  const url = id && `${process.env.REACT_APP_API_URL}/api/productions/${id}/`;
  const postUrl = `${process.env.REACT_APP_API_URL}/api/productions/`;
  const putUrl = `${process.env.REACT_APP_API_URL}/api/productions/${id}/`;
  const deleteUrl = `${process.env.REACT_APP_API_URL}/api/productions/${id}/`;
  const deleteItemsUrl = `${process.env.REACT_APP_API_URL}/api/${id}/production-items/bulk-delete/`;

  const { data, loading, error } = useGet(url);

  // const {
  //   data: optionData,
  //   loading: optionDataLoading,
  //   error: optionDataError,
  //   refetch: optionDataRefetch,
  // } = useGet(optionUrl);
  // const modifiedOems = getModifiedResponse(optionData, "oems");
  // const modifiedBillingCycles = getModifiedResponse(optionData, "bill_cycles");
  // const modifiedAutoBilling = getModifiedResponse(optionData, "auto_billings");

  const { error: postError, postData: postAction } = usePost(postUrl);
  const { error: putError, putData: putAction } = usePut(putUrl);
  const {
    data: deletedData,
    loading: deletedDataLoading,
    error: deletedDataError,
    deleteData,
  } = useDelete(deleteUrl);
  const {
    data: deletedItemsData,
    loading: deletedItemsDataLoading,
    error: deletedItemsDataError,
    deleteMultiple: deleteItemsData,
  } = useDelete(deleteItemsUrl);

  const onFinish = async (values) => {
    const modValues = {
      ...values,
    };
    try {
      if (id && !isModalForm) {
        const result = await putAction(modValues);
        if (result != null) {
          openConfirmNotification("Success");
          setTimeout(() => {
            navigate(`/production/info/${id}`);
          }, 200);
        }
      } else {
        const result = await postAction(modValues);
        if (result != null) {
          openConfirmNotification("Success");
          if (isModalForm) {
            setAccountDefaultData &&
              setAccountDefaultData((prev) => ({
                ...prev,
                ProductionNo:
                  result?.data?.ProductionNo ??
                  getProductionRowId(result?.data ?? result),
                CustomerNo: null,
              }));
            setTimeout(() => {
              onCancel();
            }, 200);
          } else {
            setTimeout(() => {
              const rid = getProductionRowId(result?.data ?? result);
              navigate(
                rid != null
                  ? `/production/info/${rid}`
                  : getProductionListPath(),
              );
            }, 200);
          }
        }
      }
    } catch (error) {
      openErrorNotification("Something went wrong.");

      console.log(error);
    }
  };

  const onReset = () => {
    // form.resetFields();
    if (isModalForm) {
      form.resetFields(["ProductionName", "ProductionDesc"]);
    }
    onCancel ? onCancel() : navigate(-1);
  };

  const onDeleteConfirm = async () => {
    try {
      await deleteData();
    } catch (error) {
      openErrorNotification("Something went wrong.");
    }
    setShowModal(false);
    setSelectedRowKeys([]);
  };
  const onDeleteItemsConfirm = async () => {
    try {
      await deleteItemsData({ ids: selectedRowKeys });
    } catch (error) {
      openErrorNotification("Something went wrong.");
    }
    setShowItemsModal(false);
    setSelectedRowKeys([]);
  };

  // Set default field value
  // useEffect(() => {
  //   if (!id) {
  //     form.setFieldsValue({
  //       OemNo: modifiedOems[0]?.value,
  //     });
  //   }
  // }, [modifiedOems]);

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
    // navigate(`/oemlist/${newSelectedRowKeys}`);
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    fixed: true,
  };
  const onRow = (record, rowIndex) => {
    return {
      onClick: (event) => {
        navigate(
          `/productionitem/${record?.ProductionNo}/info/${record?.ProductionItemNo}`
        );
      },
    };
  };

  useEffect(() => {
    if (!id || loading) return;
    const getAccountInfoById = () => {
      try {
        form.resetFields();
        if (data?.data) {
          form.setFieldsValue({
            // OemNo: data?.data?.OemNo,
            ProductionName: String(data.data.ProductionName),
            ProductionDesc: data.data.ProductionDesc
              ? String(data.data.ProductionDesc)
              : "",
          });
        } else {
          console.warn("No data found for the given ID");
        }
      } catch (error) {
        if (!loading) {
          openErrorNotification("Error fetching data!");
        }
      }
    };

    getAccountInfoById();
  }, [id, data, loading, form, type]);

  useEffect(() => {
    if (postError) {
      openErrorNotification(
        postError?.response?.data?.message || "Something went wrong",
      );
    }
  }, [postError]);

  useEffect(() => {
    if (putError) {
      openErrorNotification(
        putError?.response?.data?.message || "Something went wrong",
      );
    }
  }, [putError]);
  //toat for 404
  useEffect(() => {
    if (error) {
      openErrorNotification("Not found");
      navigate(getProductionListPath());
    }
    if (productionError) {
      openErrorNotification("Not found");
      navigate(getProductionListPath());
    }
  }, [error, productionError, navigate]);

  //toast for delete
  useEffect(() => {
    if (deletedData && !deletedDataError) {
      openConfirmNotification("Success");
      navigate(getProductionListPath());
    }
    if (deletedItemsData && !deletedItemsDataError) {
      openConfirmNotification("Success");
      productionRefetch();
    } else if (deletedDataError) {
      openErrorNotification(
        deletedDataError?.response?.data?.message || "Something went wrong"
      );
    } else if (deletedItemsDataError) {
      openErrorNotification(
        deletedItemsDataError?.response?.data?.message || "Something went wrong"
      );
    } else {
      return;
    }
  }, [deletedData, deletedItemsData, deletedItemsDataError, deletedDataError]);

  useEffect(() => {
    if (accountDefaultData) {
      form.setFieldsValue(accountDefaultData);
    }
  }, [accountDefaultData]);

  const breadcrumbItems = [
    {
      label: "Production",
      href: "/production",
    },
    {
      label: id ? (type === "info" ? "Information" : "Edit") : "Add",
      href: id
        ? type === "info"
          ? `/production/info/${id}`
          : `/production/edit/${id}`
        : "/production/add",
    },
  ];

  const buttonsData =
    type === "info"
      ? [
          {
            label: "Edit",
            icon: <EditOutlined />,
            onClick: () => {
              navigate(`/production/edit/${id}`);
            },
          },
          {
            label: "Delete",
            icon: <DeleteOutlined />,
            onClick: () => {
              setShowModal(true);
            },
          },
          {
            label: "List",
            icon: <UnorderedListOutlined />,
            onClick: () => {
              navigate(getProductionListPath());
            },
          },
        ].filter(Boolean)
      : [
          {
            label: "Apply",
            icon: <CheckCircleOutlined />,
            onClick: () => form.submit(),
          },
          {
            label: "Cancel",
            icon: <CloseOutlined />,
            onClick: onReset,
          },
        ];

  const productionItemButtonsData = [
    {
      label: "Add",
      icon: <PlusOutlined />,
      onClick: () => {
        // navigate(`/productionitem/add/${id}`);
        setOpenModal((prev) => ({
          ...prev,
          productionItemAddModal: true,
        }));
      },
    },
    {
      label: "Delete",
      icon: <DeleteOutlined />,
      onClick: () => {
        setShowItemsModal(true);
      },
      disabled: selectedRowKeys?.length === 0 ? true : false,
    },
  ];

  // const handleCreateNew = (type) => {
  //   setModalType(type);
  //   setIsOpenModal(true);
  // };
  // useEffect(() => {
  //   // optionDataRefetch();
  //   if (
  //     // defaultData?.OemNo ||
  //     defaultData?.DealerNo ||
  //     defaultData?.CustomerNo
  //   ) {
  //     form.setFieldsValue(defaultData);
  //   } else if (
  //     // accountDefaultData?.OemNo ||
  //     accountDefaultData?.DealerNo ||
  //     accountDefaultData?.CustomerNo
  //   ) {
  //     form.setFieldsValue(accountDefaultData);
  //   }
  // }, [defaultData, accountDefaultData]);

  return (
    <>
      {/* <AccountCreationModal
        isOpenModal={isOpenModal}
        modalType={modalType}
        setIsOpenModal={setIsOpenModal}
        setDefaultData={setDefaultData}
        defaultData={defaultData}
        setModalType={setModalType}
        isModal={true}
        isModalForm={true}
        title={
          <div className="flex items-center bg-gray-200 p-2 rounded-md">
            {modalType === "OEM" ? (
              <OemIcon className="text-[15px] text-black ml-1" />
            ) : null}
            <span className="text-[14px] font-[Poppins] text-black  ml-2">
              {isOpenModal ? `Add ${modalType}` : "Send Invitation"}
            </span>
          </div>
        }
      /> */}
      <Form
        validateTrigger={"onChange"}
        form={form}
        onFinish={onFinish}
        scrollToFirstError
        layout={"vertical"}
        autoComplete={"off"}
      >
        <div>
          {!isModalForm && (
            <div className="pb-4 sticky -mt-4 pt-[6px] top-[55px] z-10 bg-[#f4f5f9]">
              <CommonBreadcrumb breadcrumbItems={breadcrumbItems}>
                <CommonButton buttonsData={buttonsData} />
              </CommonBreadcrumb>
            </div>
          )}
          {
            <div
              className={`bg-white overflow-hidden ${
                isModalForm ? "" : "border rounded-[4px]"
              }`}
            >
              {!isModalForm && (
                <div className="flex items-center bg-gray-200 p-2.5">
                  <RiAlignItemBottomFill className="text-[18px] text-black " />
                  <span className="text-[.935rem] text-black font-['Poppins'] ml-2 ">
                    Production
                  </span>
                </div>
              )}
              <div className="px-2 pt-1 pb-3">
                <Row gutter={[16, 8]}>
                  <Col
                    xs={!isModalForm && 24}
                    sm={!isModalForm && 24}
                    md={!isModalForm && 12}
                    lg={!isModalForm && 12}
                    xl={!isModalForm && 12}
                    span={24}
                  >
                    <CustomInput
                      label="Name"
                      name="ProductionName"
                      disabled={type === "info"}
                      required
                      loading={loading}
                    />
                  </Col>
                  {/* </Row>
                  <Row gutter={[16, 16]}> */}
                  <Col
                    xs={!isModalForm && 24}
                    sm={!isModalForm && 24}
                    md={!isModalForm && 12}
                    lg={!isModalForm && 12}
                    xl={!isModalForm && 12}
                    span={24}
                  >
                    <CustomInput
                      label="Description"
                      name="ProductionDesc"
                      disabled={type === "info"}
                      loading={loading}
                    />
                  </Col>

                  {/* <Col
                    xs={!isModalForm && 24}
                    sm={!isModalForm && 24}
                    md={!isModalForm && 12}
                    lg={!isModalForm && 12}
                    xl={!isModalForm && 12}
                    span={24}
                  >
                    <CustomSelect
                      label="OEM"
                      name="OemNo"
                      options={modifiedOems}
                      disabled={type === "info" || accountDefaultData?.OemNo}
                      placeholder="Please select"
                      onChange={(value) => {
                        setDefaultData((prev) => ({
                          ...prev,
                          OemNo: value,
                          DealerNo: "",
                        }));

                        // setSelectedOemNo(value);
                        form.setFieldsValue({
                          DealerNo: "",
                        });
                      }}
                      required
                      handleCreateNew={
                        accountDefaultData?.OemNo ? null : handleCreateNew
                      }
                      type={"OEM"}
                    />
                  </Col> */}
                </Row>
              </div>
            </div>
          }
        </div>
      </Form>
      {isModalForm && (
        <div className="flex justify-center space-x-2 mt-2.5">
          <Button
            type="primary"
            className="mr-2 min-w-[104px] h-[30px] py-1 px-[10px] font-medium flex items-center "
            onClick={() => form.submit()}
          >
            <IoIosCheckmarkCircleOutline className="!text-[14px] font-medium" />
            <span className="">Apply</span>
          </Button>
          <Button className="reset-button" onClick={onReset}>
            <CloseOutlined />
            <span className="">Cancel</span>
          </Button>
        </div>
      )}

      <ConfirmModal
        showModal={showModal}
        setShowModal={setShowModal}
        onDeleteConfirm={onDeleteConfirm}
        setSelectedRowKeys={setSelectedRowKeys}
      />
      <ConfirmModal
        showModal={showItemsModal}
        setShowModal={setShowItemsModal}
        onDeleteConfirm={onDeleteItemsConfirm}
        setSelectedRowKeys={setSelectedRowKeys}
      />
      {type === "info" && (
        <>
          <div className="flex justify-end mb-2">
            <CommonButton buttonsData={productionItemButtonsData} />
          </div>
          <GlobalTable
            columns={ProductionItemsColumns(
              hoveredRow,
              setShowItemsModal,
              setSelectedRowKeys
            )}
            dataSource={
              productionData?.data
                ?.map((item) => ({
                  ...item,
                  key: item.ProductionItemNo,
                }))
                ?.sort((a, b) => b.ProductionItemNo - a.ProductionItemNo) || []
            }
            rowSelection={rowSelection}
            // onRow={onRow}
            onRow={(record, rowIndex) => {
              return {
                onMouseEnter: () => setHoveredRow(rowIndex),
                onMouseLeave: () => setHoveredRow(null),
                ...onRow?.(record, rowIndex),
              };
            }}
            loading={productionLoading}
          />
          <ProductionModal
            isOpenModal={openModal.productionItemAddModal}
            setIsOpenModal={(value) =>
              setOpenModal((prev) => ({
                ...prev,
                productionItemAddModal: value,
              }))
            }
            productionRefetch={productionRefetch}
            modalType="prodution"
            title={
              <div className="flex items-center bg-gray-200 p-2 rounded-md">
                <RiAlignItemBottomFill className="text-[18px] text-black " />
                <span className="text-[14px] font-[Poppins] text-black  ml-2">
                  Add Production Item
                </span>
              </div>
            }
          />
        </>
      )}
    </>
  );
};
